module.exports = __webpack_public_path__ + "img/moneda.2858f648.svg";